import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthentificationService } from 'src/app/services/auth/authentification.service';
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { TrustbuilderUtils } from 'src/app/utils/trustbuilder-utils';
@Component({
  selector: 'app-coordonnees-bancaires',
  templateUrl: './coordonnees-bancaires.component.html',
  styleUrls: ['./coordonnees-bancaires.component.scss']
})
export class CoordonneesBancairesComponent implements OnInit {

  constructor(private readonly _: SourceAuthoritesAfterAuthenticationService, private configurationService: ConfigurationService,
    private trustbuilderUtils : TrustbuilderUtils, private cookieService: CookieService, private authentificationService: AuthentificationService
  ) { 
        const username = JSON.parse(this.cookieService.get("access"))?.username
        this.login_mfa = this.trustbuilderUtils.aliasOf(username);
  }
  public fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);
  ngOnInit(): void {
  }
  login_mfa: string = "";
  configuration = this.configurationService.get();

  globalLogout() {
    this.authentificationService.httpLogout().subscribe();
    this.authentificationService.clearAccessStorage();
  }

}
